


















import Vue, { PropOptions } from 'vue';

export type CodeContentMenuItems = Blok & {
  content: Blok[];
};

export default Vue.extend({
  props: {
    blok: { type: Object, required: true } as PropOptions<CodeContentMenuItems>,
  },
});
